var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitecaseMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 24.5V21.7C56 17.7796 56 15.8194 55.237 14.3221C54.5659 13.0049 53.4951 11.9341 52.1779 11.263C50.6806 10.5 48.7204 10.5 44.8 10.5H39.2C35.2796 10.5 33.3194 10.5 31.8221 11.263C30.5049 11.9341 29.4341 13.0049 28.763 14.3221C28 15.8194 28 17.7796 28 21.7V24.5M24.5 24.5V73.5M59.5 24.5V73.5M35 49H49M42 42V56M27.3 73.5H56.7C62.5806 73.5 65.5208 73.5 67.7669 72.3556C69.7426 71.3489 71.3489 69.7426 72.3556 67.7669C73.5 65.5208 73.5 62.5806 73.5 56.7V41.3C73.5 35.4194 73.5 32.4792 72.3556 30.2331C71.3489 28.2574 69.7426 26.6511 67.7669 25.6444C65.5208 24.5 62.5806 24.5 56.7 24.5H27.3C21.4194 24.5 18.4792 24.5 16.2331 25.6444C14.2574 26.6511 12.6511 28.2574 11.6444 30.2331C10.5 32.4792 10.5 35.4194 10.5 41.3V56.7C10.5 62.5806 10.5 65.5208 11.6444 67.7669C12.6511 69.7426 14.2574 71.3489 16.2331 72.3556C18.4792 73.5 21.4194 73.5 27.3 73.5Z",
    stroke: "url(#paint0_linear_2568_9047)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2568_9047",
    x1: 10.5,
    y1: 42,
    x2: 73.5,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitecaseMedical);
export default __webpack_public_path__ + "static/media/suitecase-medical.d64083b423d5d8d4ed0f79d721fdf8a6.svg";
export { ForwardRef as ReactComponent };